import React, { useState, useEffect, Fragment } from 'react'

// Components
import Icon from '../Icon'

// Data
import DataFooterEN from './assets/dataFooterEN.json'
import DataFooterES from './assets/dataFooterES.json'
import DataFooterPT from './assets/dataFooterPT.json'

// Styles
import { FooterSocial, Social, FooterAdress, AnyQuestions } from './style'

// Types
import { DataFooterProps } from '../../types/types'
interface ILanguage {
  typeLanguage: string;
}

const Footer = ( { typeLanguage }: ILanguage ) => {
  const [ contentData, setContentData ] = useState<DataFooterProps[]>([])

  useEffect(() => {
    switch(typeLanguage) {
      case 'EN':
        setContentData(DataFooterEN)
        break
      case 'ES':
        setContentData(DataFooterES)
        break
      case 'PT':
        setContentData(DataFooterPT)
        break
    }
  }, [ typeLanguage ])

  return(
    <section className='pt-5'>
      <div className='container'>
        { contentData.map((item: DataFooterProps, index: number) => (
          <Fragment key={index}>
            <FooterSocial className='mb-2'>
              <div>
                <h2 className='fs-16 lh-20 text-blue-900 fw-600'>{item.networks}</h2>
                <Social>
                  <li key={item.titleInstagram}>
                    <a href={item.urlInstagram} title={item.titleInstagram} target='blank'>
                      <Icon width='22' height='22' icon={item.iconInstagram} directory='v2' color='gray' />
                    </a>
                  </li>
                  <li key={item.titleFacebook}>
                    <a href={item.urlFacebook} title={item.titleFacebook} target='blank'>
                      <Icon width='22' height='22' icon={item.iconFacebook} directory='v2' color='gray' />
                    </a>
                  </li>
                </Social>
              </div>
              <AnyQuestions className='mt-3 mt-md-0'>
                <h2 className='fs-16 lh-20 text-blue-900 fw-600' dangerouslySetInnerHTML={{ __html: item.questions}} />
                <p className='pt-1 mb-0' dangerouslySetInnerHTML={{ __html: item.email}} />
              </AnyQuestions>
            </FooterSocial>  
            <div className='row'>
              <div className='col-12'>
                <hr />
              </div>
              <FooterAdress className='col-12 py-3'>
                <p className='text-gray-200' dangerouslySetInnerHTML={{ __html: item.adress}} />
              </FooterAdress>
            </div>
          </Fragment>
          ))
        }
      </div>
    </section>
  )
}

export default Footer